import text from './text.json'
import './index.scss'
import Modal from '../modal'
import {useDispatch, useSelector} from 'react-redux'
import {addFeedback, setFeedbackModalIsActive} from '../../../stores/feedback'
import {feedbackSchema} from '../../../utils/validation'
import Textarea from '../textarea'
import ButtonLoader from '../button/ButtonLoader'
import {SimpleBlueButton} from '../button'
import {Formik} from 'formik'
import {useState} from 'react'

const Feedback = () => {
    const MIN_FEEDBACK_LENGTH = 20
    const feedbackModalIsActive = useSelector(state => state.feedback.feedbackModalIsActive)
    const [buttonIsDisabled, setButtonIsDisabled] = useState(false)
    const [active, setActive] = useState(null)
    const dispatch = useDispatch()
    const toggleFeedbackModal = () => {
        dispatch(setFeedbackModalIsActive(false))
    }
    const names = {
        feedback: 'feedback'
    }
    const initialFormValues = {
        feedback: ''
    }
    const handleInfo = (index, state) => {
        state ? setActive(index) : setActive(null)
    }
    const userAddFeedback = async(values, {setFieldError, resetForm}) => {
        setButtonIsDisabled(true)
        await dispatch(addFeedback(values, setFieldError, resetForm, toggleFeedbackModal))
        setButtonIsDisabled(false)
    }
    return (
        <Modal
            className={feedbackModalIsActive ? 'active' : ''}
            closeModal={toggleFeedbackModal}
            title={text.feedback_title}>
            <Formik
                enableReinitialize={true}
                initialValues={initialFormValues}
                onSubmit={userAddFeedback}
                validationSchema={feedbackSchema}
                validateOnBlur={false}
                validateOnChange={false}
            >
                {({values, handleSubmit, handleChange, errors}) => (
                    <form onSubmit={handleSubmit} className="modal-body">
                        <Textarea
                            name={names.feedback}
                            value={values.feedback}
                            error={errors.feedback}
                            onChange={handleChange}
                            placeholder={text.placeholder}
                            infoText={text.info}
                            minLength={MIN_FEEDBACK_LENGTH}
                            activeInfo={active === names.feedback}
                            handleInfo={(state) => handleInfo(names.feedback, state)}
                        />
                        <SimpleBlueButton
                            disabled={buttonIsDisabled}
                            type="submit"
                        >
                            {buttonIsDisabled && <ButtonLoader/>}
                            <span>{text.button_text}</span>
                        </SimpleBlueButton>
                    </form>
                )}
            </Formik>
        </Modal>
    )
}

export default Feedback
